import { parseQueryString } from '../locationUtils';
import { removeMarkdownFromText } from '../markdownUtils';

export const capitalize = (word = '') =>
  word ? word[0].toUpperCase() + word.substring(1) : '';

export const parseUrl = (url) => url.split('?');

export const getQueryPrefixes = (query) => {
  if (!query) {
    return '';
  }

  const acceptableQueryParams = {
    branch: (queryValue) => `Branch ${queryValue} | `,
    localViewerId: () => `Local Preview | `,
  };

  const parsedQuery = parseQueryString(query);

  for (const [key, val] of Object.entries(parsedQuery)) {
    if (acceptableQueryParams[key]) {
      return acceptableQueryParams[key](val);
    }
  }
  return '';
};

export const transformUrlToTitleFormat = (urlPart = '') => {
  return urlPart
    .split('-')
    .filter((_) => _)
    .map(capitalize)
    .join(' ');
};

const removeLastWordFromString = (str) => {
  const lastIndex = str.lastIndexOf(' ');
  return str.substring(0, lastIndex);
};

const getShortMetaDescription = (metaDescription) =>
  metaDescription.length > 160
    ? `${removeLastWordFromString(metaDescription.slice(0, 160))} ...`
    : metaDescription;

export const getMetaDescriptionFromMemberData = (
  summary = '',
  _description = '',
) => {
  const getDescription = () => {
    if (!_description) {
      return '';
    }
    if (Array.isArray(_description)) {
      return _description.join('');
    }
    return _description;
  };
  const description = getDescription(_description);
  const textWithMarkdownAndHtml = description
    ? `${summary} ${description}`
    : summary;
  const metaDescription = removeMarkdownFromText(textWithMarkdownAndHtml);
  return getShortMetaDescription(metaDescription).trim();
};
